module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Fifty-Shades-Freed.e007416.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Fifty-Shades-Freed.jpg
// module id = GTqC
// module chunks = 0